<template>
  <ul class="list-inline">
    <li>
      <BalanceAmount currency="USD" icon-class="cap-icon-dollar" :balances="balances"></BalanceAmount>
    </li>
    <li>
      <BalanceAmount currency="EUR" icon-class="cap-icon-euro" :balances="balances"></BalanceAmount>
    </li>
    <li>
      <BalanceAmount currency="RUR" icon-class="cap-icon-rub" :balances="balances"></BalanceAmount>
    </li>
    <li>
      <BalanceAmount currency="BTC" icon-class="cap-icon-bitcoin" :balances="balances"></BalanceAmount>
    </li>
    <li>
      <BalanceAmount currency="USDT" :balances="balances">
        <template v-slot:icon>
          <div class="center-icon">
            <inline-svg :src="require('./tether-usdt.svg')" width="13" height="14"></inline-svg>
          </div>
        </template>
      </BalanceAmount>
    </li>
    <li>
      <BalanceAmount currency="ETH" icon-class="capitalist-icon-ethereum" :balances="balances"></BalanceAmount>
    </li>
    <li>
      <BalanceAmount currency="USDC" :balances="balances">
        <template v-slot:icon>
          <div class="center-icon">
          <inline-svg :src="require('./usd-coin-balance-1.svg')" width="14" height="14"></inline-svg>
          </div>
        </template>
      </BalanceAmount>
    </li>
  </ul>
</template>

<script lang="ts">
import InlineSvg from 'vue-inline-svg';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ViewFiltersMixin } from '@/models/filters/view';
import BalanceAmount from '@/views/layouts/header/BalanceAmount.vue';
import { Balances } from '@/views/layouts/header/header';
import { CurrencyCode, isFiatCurrency } from "@/models/core/currency";

@Component({
  name: 'header-balance',
  components: { BalanceAmount, InlineSvg },

  mixins: [ViewFiltersMixin],
})
export default class HeaderBalance extends Vue {
  @Prop({ default: null })
  defaultBalances!: Record<string, any> | null;

  balances = new Balances();

  windowActive = false

  mounted() {
    this.balances.data = this.defaultBalances;
    if (!this.defaultBalances) this.balances.updateBalances();
    else this.balances.delayedUpdateBalances();

    window.addEventListener('blur', this.onTabBlur);
    window.addEventListener('focus', this.onTabFocus);
  }

  onTabBlur(e) {
    this.windowActive = false;
    this.balances.autoUpdate = false;
    this.balances.resetAutoUpdateTimer();
  }

  onTabFocus(e) {
    this.windowActive = true;
    this.balances.autoUpdate = true;
    this.balances.delayedUpdateBalances();
  }
}
</script>

<style scoped lang="less">
.center-icon {
  //display: inline-block;
  //justify-content: center;
  //align-items: center;
  display: flex;
  align-items: center;
}
.list-inline {
  //width: 60%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px 10px;
  li {
    display: inline-block;
    a {
      display: grid;
      grid-template-columns: auto auto;
      align-items: center;
      justify-content: center;
      grid-gap: 0 5px;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "Баланс": "Баланс"
  },
  "en": {
    "Баланс": "Balance"
  }
}
</i18n>
